"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemDenominationTypeEnum = exports.MenuItemRedeemableRegionEnum = exports.MenuItemToJSON = exports.MenuItemFromJSONTyped = exports.MenuItemFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function MenuItemFromJSON(json) {
    return MenuItemFromJSONTyped(json, false);
}
exports.MenuItemFromJSON = MenuItemFromJSON;
function MenuItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'category': json['category'],
        'images': !(0, runtime_1.exists)(json, 'images') ? undefined : (json['images'].map(_1.AssetFromJSON)),
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'price': json['price'],
        'sortOrder': !(0, runtime_1.exists)(json, 'sortOrder') ? undefined : json['sortOrder'],
        'taxRate': json['taxRate'],
        'caloriesBase': !(0, runtime_1.exists)(json, 'caloriesBase') ? undefined : json['caloriesBase'],
        'caloriesMax': !(0, runtime_1.exists)(json, 'caloriesMax') ? undefined : json['caloriesMax'],
        'minQuantity': !(0, runtime_1.exists)(json, 'minQuantity') ? undefined : json['minQuantity'],
        'maxQuantity': !(0, runtime_1.exists)(json, 'maxQuantity') ? undefined : json['maxQuantity'],
        'minCartQuantity': !(0, runtime_1.exists)(json, 'minCartQuantity') ? undefined : json['minCartQuantity'],
        'maxCartQuantity': !(0, runtime_1.exists)(json, 'maxCartQuantity') ? undefined : json['maxCartQuantity'],
        'isAlcohol': !(0, runtime_1.exists)(json, 'isAlcohol') ? undefined : json['isAlcohol'],
        'isActive': !(0, runtime_1.exists)(json, 'isActive') ? undefined : json['isActive'],
        'isEnabled': !(0, runtime_1.exists)(json, 'isEnabled') ? undefined : json['isEnabled'],
        'comingSoon': !(0, runtime_1.exists)(json, 'comingSoon') ? undefined : json['comingSoon'],
        'featured': !(0, runtime_1.exists)(json, 'featured') ? undefined : json['featured'],
        'outOfStock': !(0, runtime_1.exists)(json, 'outOfStock') ? undefined : json['outOfStock'],
        'serviceAvailabilities': !(0, runtime_1.exists)(json, 'serviceAvailabilities') ? undefined : (json['serviceAvailabilities'].map(_1.BusinessServiceAvailabilityFromJSON)),
        'customizations': !(0, runtime_1.exists)(json, 'customizations') ? undefined : (json['customizations'].map(_1.MenuCustomizationFromJSON)),
        'nftGroupings': !(0, runtime_1.exists)(json, 'nftGroupings') ? undefined : json['nftGroupings'],
        'chowlyId': !(0, runtime_1.exists)(json, 'chowlyId') ? undefined : json['chowlyId'],
        'chowlyExternalId': !(0, runtime_1.exists)(json, 'chowlyExternalId') ? undefined : json['chowlyExternalId'],
        'oloId': !(0, runtime_1.exists)(json, 'oloId') ? undefined : json['oloId'],
        'oloChainId': !(0, runtime_1.exists)(json, 'oloChainId') ? undefined : json['oloChainId'],
        'itsaCheckmateId': !(0, runtime_1.exists)(json, 'itsaCheckmateId') ? undefined : json['itsaCheckmateId'],
        'isGiftCard': !(0, runtime_1.exists)(json, 'isGiftCard') ? undefined : json['isGiftCard'],
        'redeemableRegion': !(0, runtime_1.exists)(json, 'redeemableRegion') ? undefined : json['redeemableRegion'],
        'denominationType': !(0, runtime_1.exists)(json, 'denominationType') ? undefined : json['denominationType'],
        'fixedAmounts': !(0, runtime_1.exists)(json, 'fixedAmounts') ? undefined : json['fixedAmounts'],
        'minAmount': !(0, runtime_1.exists)(json, 'minAmount') ? undefined : json['minAmount'],
        'maxAmount': !(0, runtime_1.exists)(json, 'maxAmount') ? undefined : json['maxAmount'],
        'tilloProductId': !(0, runtime_1.exists)(json, 'tilloProductId') ? undefined : json['tilloProductId'],
        'giftCardImageUrl': !(0, runtime_1.exists)(json, 'giftCardImageUrl') ? undefined : json['giftCardImageUrl'],
        'brand': !(0, runtime_1.exists)(json, 'brand') ? undefined : json['brand'],
        'ourDiscount': !(0, runtime_1.exists)(json, 'ourDiscount') ? undefined : json['ourDiscount'],
        'fuelBackStandard': !(0, runtime_1.exists)(json, 'fuelBackStandard') ? undefined : json['fuelBackStandard'],
        'fuelBackIndustryPass': !(0, runtime_1.exists)(json, 'fuelBackIndustryPass') ? undefined : json['fuelBackIndustryPass'],
        'xpStandard': !(0, runtime_1.exists)(json, 'xpStandard') ? undefined : json['xpStandard'],
        'xpIndustryPass': !(0, runtime_1.exists)(json, 'xpIndustryPass') ? undefined : json['xpIndustryPass'],
    };
}
exports.MenuItemFromJSONTyped = MenuItemFromJSONTyped;
function MenuItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'category': value.category,
        'images': value.images === undefined ? undefined : (value.images.map(_1.AssetToJSON)),
        'name': value.name,
        'description': value.description,
        'price': value.price,
        'sortOrder': value.sortOrder,
        'taxRate': value.taxRate,
        'caloriesBase': value.caloriesBase,
        'caloriesMax': value.caloriesMax,
        'minQuantity': value.minQuantity,
        'maxQuantity': value.maxQuantity,
        'minCartQuantity': value.minCartQuantity,
        'maxCartQuantity': value.maxCartQuantity,
        'isAlcohol': value.isAlcohol,
        'isActive': value.isActive,
        'isEnabled': value.isEnabled,
        'comingSoon': value.comingSoon,
        'featured': value.featured,
        'outOfStock': value.outOfStock,
        'serviceAvailabilities': value.serviceAvailabilities === undefined ? undefined : (value.serviceAvailabilities.map(_1.BusinessServiceAvailabilityToJSON)),
        'customizations': value.customizations === undefined ? undefined : (value.customizations.map(_1.MenuCustomizationToJSON)),
        'nftGroupings': value.nftGroupings,
        'chowlyId': value.chowlyId,
        'chowlyExternalId': value.chowlyExternalId,
        'oloId': value.oloId,
        'oloChainId': value.oloChainId,
        'itsaCheckmateId': value.itsaCheckmateId,
        'isGiftCard': value.isGiftCard,
        'redeemableRegion': value.redeemableRegion,
        'denominationType': value.denominationType,
        'fixedAmounts': value.fixedAmounts,
        'minAmount': value.minAmount,
        'maxAmount': value.maxAmount,
        'tilloProductId': value.tilloProductId,
        'giftCardImageUrl': value.giftCardImageUrl,
        'brand': value.brand,
        'ourDiscount': value.ourDiscount,
        'fuelBackStandard': value.fuelBackStandard,
        'fuelBackIndustryPass': value.fuelBackIndustryPass,
        'xpStandard': value.xpStandard,
        'xpIndustryPass': value.xpIndustryPass,
    };
}
exports.MenuItemToJSON = MenuItemToJSON;
/**
* @export
* @enum {string}
*/
var MenuItemRedeemableRegionEnum;
(function (MenuItemRedeemableRegionEnum) {
    MenuItemRedeemableRegionEnum["US"] = "US";
    MenuItemRedeemableRegionEnum["CA"] = "CA";
    MenuItemRedeemableRegionEnum["UK"] = "UK";
    MenuItemRedeemableRegionEnum["EU"] = "EU";
    MenuItemRedeemableRegionEnum["AU"] = "AU";
    MenuItemRedeemableRegionEnum["GLOBAL"] = "GLOBAL";
})(MenuItemRedeemableRegionEnum = exports.MenuItemRedeemableRegionEnum || (exports.MenuItemRedeemableRegionEnum = {}));
/**
* @export
* @enum {string}
*/
var MenuItemDenominationTypeEnum;
(function (MenuItemDenominationTypeEnum) {
    MenuItemDenominationTypeEnum["FIXED"] = "FIXED";
    MenuItemDenominationTypeEnum["OPEN"] = "OPEN";
})(MenuItemDenominationTypeEnum = exports.MenuItemDenominationTypeEnum || (exports.MenuItemDenominationTypeEnum = {}));
